import React from "react"
import types from "prop-types"
import { FormsyCheckbox } from "shared/checkboxes/Checkbox"

const DESCRIPTION = "If checked, department will appear at the bottom of location question options."
const LABEL = "Order last on forms"

const ListLastOnForms = ({ department = undefined }) => {
  const { listLastOnForms } = department

  return (
    <>
      <div className="text-sm mt-2">
        <label className="mr-2">{LABEL}</label>
        <FormsyCheckbox
          className="input-focus-ring"
          name="list_last_on_forms"
          value={listLastOnForms}
        />
      </div>

      <div className="text-xs italic">
        {DESCRIPTION}
      </div>
    </>
  )
}

ListLastOnForms.propTypes = {
  department: types.object,
}

export default ListLastOnForms
